(function () {
  if (window.__shCountdownLoaded) return;
  window.__shCountdownLoaded = true;

  function pad(n) {
    n = Math.max(0, n);
    return n < 10 ? '0' + n : String(n);
  }

  function tick(el) {
    var deadlineStr = el.getAttribute('data-deadline');
    if (!deadlineStr) return;
    var deadline = new Date(deadlineStr);
    if (isNaN(deadline.getTime())) return;

    var grid = el.querySelector('[data-sh-countdown-grid]');
    var expired = el.querySelector('[data-sh-countdown-expired]');
    var daysEl = el.querySelector('[data-sh-cd-days]');
    var hoursEl = el.querySelector('[data-sh-cd-hours]');
    var minutesEl = el.querySelector('[data-sh-cd-minutes]');
    var secondsEl = el.querySelector('[data-sh-cd-seconds]');

    function render() {
      var now = new Date().getTime();
      var distance = deadline.getTime() - now;

      if (distance <= 0) {
        if (el._shCountdownTimer) clearInterval(el._shCountdownTimer);
        var wrap = el.closest('[data-sh-hide-expired]');
        if (wrap) {
          wrap.hidden = true;
          return;
        }
        if (grid) grid.hidden = true;
        if (expired) expired.hidden = false;
        return;
      }

      var days = Math.floor(distance / 86400000);
      var hours = Math.floor((distance % 86400000) / 3600000);
      var minutes = Math.floor((distance % 3600000) / 60000);
      var seconds = Math.floor((distance % 60000) / 1000);

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    }

    render();
    el._shCountdownTimer = setInterval(render, 1000);
  }

  function init() {
    var nodes = document.querySelectorAll('[data-sh-countdown]');
    nodes.forEach(function (el) {
      tick(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
